import { FC, memo } from "react";

import { ImageProps } from "next/image";
import { StyledSidebarImage } from "./styles";

export interface SidebarImageProps extends ImageProps {
  isCurrent: boolean;
}

const _SidebarImage: FC<SidebarImageProps> = (props) => {
  const { isCurrent, ...restProps } = props;

  return <StyledSidebarImage $isCurrent={isCurrent} {...restProps} />;
};

export const SidebarImage = memo(_SidebarImage);
